import request from "@/utils/request";

//公司列表
export function getCompanyListApi(data) {
  return request({
    url: `/fmsapi/company/GetCompanys`,
    method: "post",
    data,
  });
}
